import {
  SET_FORM_ID,
  SET_FIELD_VALUE,
  SUBMIT_FORM_FOR_VALIDATION,
  VALIDATE_FIELD,
  PAGE_FORWARD,
  PAGE_BACK,
  SET_DATE_RANGE_VALUES,
  SET_MULTIPLE_CHECKBOX_VALUE,
  SET_SINGLE_CHECKBOX_VALUE,
} from './types';

const action = (type, payload = {}) => ({ type, ...payload });

export const onSubmit = formId =>
  action(SUBMIT_FORM_FOR_VALIDATION, { formId });
export const setFormId = formId => action(SET_FORM_ID, { formId });
export const setValue = (formId, id, value) =>
  action(SET_FIELD_VALUE, { formId, id, value });
export const setSingleCheckboxValue = (formId, id, value) =>
  action(SET_SINGLE_CHECKBOX_VALUE, { formId, id, value });
export const setMultipleCheckboxValue = (formId, id, label, value) =>
  action(SET_MULTIPLE_CHECKBOX_VALUE, { formId, id, label, value });
export const setDateRangeValues = (formId, id, dateType, value) =>
  action(SET_DATE_RANGE_VALUES, { formId, id, dateType, value });
export const onValidateField = (formId, id, value) =>
  action(VALIDATE_FIELD, { formId, id, value });
export const doTogglePageForward = (formId, pageIndex) =>
  action(PAGE_FORWARD, { formId, pageIndex });
export const doTogglePageBack = (formId, pageIndex) =>
  action(PAGE_BACK, { formId, pageIndex });


export const actions = {
  onSubmit,
  setFormId,
  setValue,
  setSingleCheckboxValue,
  setMultipleCheckboxValue,
  onValidateField,
  doTogglePageForward,
  doTogglePageBack,
  }
